export const MODAL_ID = 'modal-root'
export const MODAL_OVERLAY = 'modal-overlay'
export const MODAL_BODY_CLASSNAME = 'modal-body'
export const MODAL_HEADER_CLASSNAME = 'modal-header'
